// Création de l'objet à envoyer au back
const formaterContacter = async (dataForm) => {
    const fichiers = [];

    if (dataForm.piecesJointes) {
        for (let i = 0; i < dataForm.piecesJointes.length; i += 1) {
            // eslint-disable-next-line no-await-in-loop
            fichiers[i] = await dataForm.piecesJointes[i].getFileToSend();
        }
    }

    return {
        nom: dataForm.nom,
        prenom: dataForm.prenom,
        prefecture: dataForm.prefecture,
        emailExpediteur: dataForm.email,
        theme: dataForm.theme,
        message: dataForm.message,
        pieceJointe: fichiers,
    };
};

export default formaterContacter;
